import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledBusinessInformation = styled('div')`
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;

  .ant-tabs-nav {
    margin: 0 0 20px 0;
  }
  .page-footer {
    position: fixed;
  }
`;

export const StyledBusinessInformationFooter = styled('div')`
  position: fixed;
  width: -webkit-fill-available;
  bottom: 0;
  .ant-btn {
    border-radius: 3px;
  }
  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: none;
  }
`;

export const StyledBusinessInformationFooterMobile = styled('div')`
  display: none;
  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: block;
    position: relative;
    .footer {
      display: flex;
      justify-content: center;
      gap: 10px;
      .ant-btn {
        width: 100%;
      }
    }
  }
`;

export const BusinessInformationWrapper = styled('div')`
  height: 100%;
  width: 100%;
  .page-layout {
    border-radius: 0;
  }
`;
